function Break({ width = '100%', border = '1px solid #FFFFFF17' }: { width?: string; border?: string }) {
  return (
    <span
      style={{
        width,
        border,
      }}
    />
  )
}

export default Break
